import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const PopupContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  overflow-y: auto;
`;
export const PopupInner = styled.div`
  position: absolute;
  left: 25%;
  right: 25%;
  top: 0;
  bottom: auto;
  width: 768px;
  background: #f8f9fa;
  border-radius: 5px;
  margin: 68px 0 80px;
  padding-bottom: 30px;
  z-index: 200;
`;

export const Top = styled.div`
  padding: 0 8px 8px 30px;
  display: flex;
  flex-direction: row;
  margin: 30px 16px 8px 0;

  a {
    margin-top: -10px;

    img {
      width: 18px;
      height: 18px;
    }
  }

  img {
    width: 23px;
    height: 18px;
    margin: 3px 0 auto 2px;
  }
  h1 {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    color: #444444;
    margin-left: 21px;
    margin-bottom: 12px;
    padding-right: 5%;
  }
`;

export const Main = styled.div`
  margin: 0;
  min-height: 24px;
  padding: 0 8px 8px 30px;
  position: relative;
  width: 552px;
  float: left;
  #div {
    display: flex;
    flex-direction: row;
    margin-left: 51px !important;
    margin-top: 5px;
  }
  #icon {
    width: 12px;
    height: 12px;
    margin-right: 2px;
  }
  #options {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 12px;
    color: #777777;
  }
`;

export const SideBar = styled.div`
  padding: 0 16px 8px 8px;
  overflow: hidden;
  float: right;
  h1 {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    color: #777777;
    margin-bottom: 12px;
  }
`;

export const SideCard = styled(Link)`
  display: flex;
  flex-direction: row;
  width: 162px;
  height: 32px;
  background: #ebebeb;
  border-radius: 3px;
  margin-bottom: 10px;
  img {
    width: 15px;
    height: 15px;
    margin: 8px;
    margin-right: 7px;
  }
  p {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 540;
    font-size: 12px;
    line-height: 14px;
    margin: auto;
    margin-left: 0;
    color: #444444;
  }

  &:hover,
  &:focus {
    color: #495057;
    background-color: #dae0e5 !important;
    border: none;
    outline: none;
  }
`;

export const Requester = styled.div`
  display: flex;
  flex-direction: row;
  img {
    width: 30px;
    height: 30px;

  }
  div {
    display:flex;
    flex-direction: column;
    margin-left: 18px;
  }

  h1 {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    color: #777777;
    }
  h2 {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    color: #777777;
    margin-bottom: 6px;
    }
  p {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 14px;
    color: #777777;
    margin-bottom: 10px;
    }
  }
`;

export const Description = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 23px;
  img {
    padding-top: 4px;
    width: 23px;
    height: 15px;
    margin-left:3px;

  }
  div {
    display:flex;
    flex-direction: column;
    margin-left: 21px;
    width: 540px;
  }

  h1 {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #777777;
  }
  p {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 14px;
    color: #777777;
    margin-bottom: 10px;
    }
  }
`;

export const DescriptionBody = styled.div`
  display: flex;
  flex-direction: line;
  margin-left: 42px;
`;
export const Input = styled.input`
  width: 370px;
  background-color: #ffffff;
  border: 1px solid #dddddd;
  height: 32px;
  border-radius: 0.25rem;
  padding-top: 2px;
  padding-left: 11px;
  font-family: 'Roboto', Arial, Helvetica, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;

  &:focus {
    outline: none;
    &::placeholder {
      color: transparent;
    }
  }

  &::placeholder {
    color: rgba(0, 0, 0, 0.35);
    font-size: 12px;
  }
`;

export const Button = styled.button`
  display: flex;
  height: 32px;
  width: 162px;
  background: #444444;
  margin-left: 8px;
  border-radius: 3px;
  border: 0;
  align-items: center;

  img {
    width: 15px;
    height: 15px;
    margin-left: 8px;
  }
  p {
    width: 123px;
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-size: 12px;
    color: #ffffff;
    margin: 0;
  }

  &:hover,
  &:focus {
    color: #495057;
    background-color: #dae0e5 !important;
    border: none;
    outline: none;
  }

  &:active {
    background-color: #9ae0e5 !important;
  }
`;

export const Equipment = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 23px;
  img {
    padding-top: 4px;
    width: 23px;
    height: 23px;
    margin-left:3px;

  }
  div {
    display:flex;
    flex-direction: column;
    margin-left: 21px;
  }

  h1 {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #777777;
  }
  p {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 14px;
    color: #777777;
    margin-bottom: 10px;
    }
  }
`;

export const EquipmentList = styled.div`
  display: flex;
  flex-direction: line;
  width: 540px;
  padding-left: 40px;
  border-radius: 5px;
`;

export const Attachments = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 0;
  width: 95%;
  #img {
    width: 23px;
    height: 23px;
    margin-left: 3px;
  }

  h1 {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #777777;
    margin: 2px auto 11px 0;
  }

  div {
    margin: 0;
  }

  #body {
    margin-left: 21px !important;
    width: 100%;
  }

  hr {
    width: 100%;
    margin-top: 6px !important;
    margin-bottom: 25px !important;
  }
`;

export const AttachList = styled.div`
  display: flex;
  flex-direction: row;
  img {
    width: 62px;
    height: 62px;
    padding: 8.5px;
    filter: none;
    background-color: #fff;
  }
  div {
    margin: 0 !important;
  }
`;

export const Responsibles = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 37px;

  #img {
    width: 23px;
    height: 23px;
    margin-left: 3px;
  }

  div {
    display: flex;
    flex-direction: column;
    margin-left: 21px;
  }

  h1 {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #777777;
  }

  #add {
    width: 30px;
    height: 30px;
    margin-top: -1px;
    margin-left: -1px;
  }
`;

export const AtvHead = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 2px;
  img {
    width: 23px;
    height: 16px;
    margin-top: 2px;
    margin-left: 3px;
  }
  h1 {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #777777;
    margin-left: 21px;
  }
`;

export const Comments = styled.div`
  display: flex;
  flex-direction: column;
  width: 95%;

  div {
    display: flex;
    flex-direction: row;
    margin-top: 15px;
  }

  img {
    width: 32px;
    height: 32px;
    margin-top: -1px;
  }

  input {
    width: 100%;
    height: 32px;
    background-color: #ffffff;
    border: 1px solid #dddddd;
    border-radius: 3px;
    margin-left: 15px;
    padding-top: 2px;
    padding-left: 11px;
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;

    &:focus {
      outline: none;
      &::placeholder {
        color: transparent;
      }
    }

    &::placeholder {
      color: rgba(0, 0, 0, 0.35);
    }
  }

  p {
    padding: 8px 9px 8px 13px;
    margin-left: 15px;

    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-style: normal;

    font-size: 12px;
    line-height: 14px;
    color: #777777;

    background-color: #ffffff;
    border: 1px solid #dddddd;
    border-radius: 3px;
    margin-bottom: 0;
  }
`;

export const AddBy = styled.div`
  display: flex;
  flex-direction: row;

  div {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
  }

  img {
    width: 32px;
    height: 32px;
    margin-top: -1px;
  }

  p {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-size: 12px;
    line-height: 14px;
    color: #777777;
    margin-bottom: 4px;
  }
  h3 {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 12px;
    color: #bbbbbb;
  }
`;
export const Success = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 30px;

  h1 {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 23px;

    color: #3bb54a;
    margin: auto;
    margin-right: 10px;
  }

  img {
    width: 39px;
    height: 39px;
    margin: auto;
    margin-left: 0;
  }
`;
